import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { obtenerSesion, actualizarOperador } from '../utils/sesion';
import {
  IconContrasena,
  IconMostrarContrasena,
  IconOcultarContrasena,
  IconAdvertencia,
  IconExito,
} from '../components/icons';
import '../styles/login.css';

function CampoPassword({ id, label, valor, onChange, autoComplete }) {
  const [mostrar, setMostrar] = useState(false);
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <div className="input-wrapper input-wrapper-password">
        <span className="input-icon">
          <IconContrasena size={18} />
        </span>
        <input
          id={id}
          className="form-input"
          type={mostrar ? 'text' : 'password'}
          value={valor}
          onChange={onChange}
          autoComplete={autoComplete}
          minLength={8}
          required
        />
        <button
          type="button"
          className="btn-mostrar-contrasena"
          onClick={() => setMostrar((v) => !v)}
          aria-label={mostrar ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        >
          {mostrar ? <IconOcultarContrasena size={18} /> : <IconMostrarContrasena size={18} />}
        </button>
      </div>
    </div>
  );
}

function CambiarPassword() {
  const navigate = useNavigate();
  const sesion = obtenerSesion();
  const obligatorio = Boolean(sesion?.operador?.debe_cambiar_password);

  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNueva, setPasswordNueva] = useState('');
  const [passwordNuevaConfirmar, setPasswordNuevaConfirmar] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [exito, setExito] = useState(false);

  async function manejarSubmit(evento) {
    evento.preventDefault();
    setError('');

    if (passwordNueva !== passwordNuevaConfirmar) {
      setError('La confirmación no coincide con la contraseña nueva.');
      return;
    }
    if (passwordNueva.length < 8) {
      setError('La contraseña nueva tiene que tener al menos 8 caracteres.');
      return;
    }

    setEnviando(true);
    try {
      await api.post('/auth/cambiar-password', {
        password_actual: passwordActual,
        password_nueva: passwordNueva,
      });
      actualizarOperador({ debe_cambiar_password: false });
      setExito(true);
      setTimeout(() => navigate('/caja', { replace: true }), 1200);
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo cambiar la contraseña.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-gradient" />
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo-betech.svg" alt="Betech" className="logo-img" />
        </div>
        <h1 className="login-title">Cambiar contraseña</h1>
        <p className="login-subtitle">
          {obligatorio
            ? 'Por seguridad, tenés que cambiar tu contraseña antes de seguir.'
            : 'Elegí una contraseña nueva para tu usuario.'}
        </p>

        <form className="login-form" onSubmit={manejarSubmit}>
          <CampoPassword
            id="password_actual"
            label="Contraseña actual"
            valor={passwordActual}
            onChange={(e) => setPasswordActual(e.target.value)}
            autoComplete="current-password"
          />
          <CampoPassword
            id="password_nueva"
            label="Contraseña nueva"
            valor={passwordNueva}
            onChange={(e) => setPasswordNueva(e.target.value)}
            autoComplete="new-password"
          />
          <CampoPassword
            id="password_nueva_confirmar"
            label="Repetí la contraseña nueva"
            valor={passwordNuevaConfirmar}
            onChange={(e) => setPasswordNuevaConfirmar(e.target.value)}
            autoComplete="new-password"
          />

          {error && (
            <p className="mensaje-error">
              <IconAdvertencia size={16} />
              {error}
            </p>
          )}
          {exito && (
            <p className="mensaje-exito">
              <IconExito size={16} />
              Contraseña actualizada. Volviendo a Caja…
            </p>
          )}

          <button type="submit" className="boton boton-primario" disabled={enviando || exito}>
            {enviando ? 'Guardando…' : 'Cambiar contraseña'}
          </button>

          {!obligatorio && (
            <button
              type="button"
              className="boton boton-secundario boton-ancho"
              onClick={() => navigate('/caja')}
            >
              Cancelar
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

export default CambiarPassword;
